import { Component, inject, Input } from '@angular/core';
import { GtmService } from '@core/utils-v2/gtm/gtm.service';

declare let dataLayer: any;

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input() set banner(value: any) {
    this.elementoData = value;
    this.bannerCms = this.elementoData.element;
    this.bannerCms.startDate = new Date(this.bannerCms.startDate);
    this.bannerCms.expirationDate = new Date(this.bannerCms.expirationDate);
    this.viewBanner =
      this.bannerCms.startDate <= this.today &&
      this.today <= this.bannerCms.expirationDate;
  }
  bannerCms: any;
  elementoData: any;
  today = new Date();
  viewBanner: boolean = true;

  private readonly gtmService: GtmService = inject(GtmService);

  onClickBanner(title: string): void {
    this.gtmService.click({
      dataLayer,
      textId: title,
      prefix: 'interbanner',
    });
  }
}
